import { Component } from '@angular/core';
import { ModalComponent } from '../../core/modal.component';
import { ActiveModal } from '../../core/modal.service';
import { WidgetMapService } from '../widget-map.service';
import { Widget, WidgetMap } from '../../models/widget';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { WidgetService } from '../widget.service';

@Component({
  selector: 'cw-move-map-modal',
  templateUrl: './move-map-modal.component.html',
  styleUrls: ['./move-map-modal.component.css']
})
export class MoveMapModalComponent extends ModalComponent {
  widget: Widget;
  map: WidgetMap;
  form: FormGroup;
  widgets: Widget[];
  isSaving: boolean = false;

  constructor(public modal: ActiveModal,
              private fb: FormBuilder,
              private widgetService: WidgetService,
              private mapService: WidgetMapService) {
    super(modal);
    this.form = fb.group({
      widget: [Validators.required, '']
    });
  }

  init(widget: Widget, map: WidgetMap) {
    this.widget = widget;
    this.map = map;
    this.loadWidgets();
    this.opened = true;
  }

  save() {
    const widgetId = parseInt(this.form.get('widget').value, 10);
    const newWidget = this.widgets.find(w => w.id === widgetId);
    this.isSaving = true;
    if (!newWidget) {
      return false;
    }
    this.mapService.move(this.map, newWidget)
      .finally(() => {
        this.isSaving = false;
      })
      .subscribe(map => {
        this.modal.close(map);
      });
  }

  private loadWidgets() {
    this.widgetService.getForProject(this.widget.project)
      .subscribe(widgets => {
        this.widgets = widgets;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/widgets/move-map-modal/move-map-modal.component.ts